// 是否在app内
let checkIsApp = function() {
  let uniHm = sessionStorage.getItem('uniHm') // uniHm=1 表示uniapp打包成鸿蒙app
  let isApp = false
  try{ window.getData = function(data) { } }catch(err){ }
  try {
    window.webkit.messageHandlers.request.postMessage('getData');
    isApp = true
  } catch (err) {
    try{
      window.gk.request('getData')
      isApp = true
    } catch(err){
      isApp = false
    }
  }
  if (uniHm == '1') {
    isApp = true
  }
  return isApp
}
let uilts = {
  install(Vue, options) {
    Vue.prototype.utils = {
      isIphoneX: function () { // iphonex 系列
        let uniHm = sessionStorage.getItem('uniHm') // uniHm=1 表示uniapp打包成鸿蒙app
        if (uniHm == '1') {
          return true
        }
        if (/iphone/gi.test(window.navigator.userAgent)) {
          /* iPhone X、iPhone XS */
          var x = (window.screen.width === 375 && window.screen.height === 812);
          /* iPhone XS Max */
          var xsMax = (window.screen.width === 414 && window.screen.height === 896);
          /* iPhone XR */
          var xR = (window.screen.width === 414 && window.screen.height === 896);
          if (x || xsMax || xR) {
            return true;
          } else {
            return false;
          }
        } else {
          return false
        }
      },
      //判断ios、Android、pc端
      isIosOrAndroidOrPc: function () {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"
        ];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        if (!flag) {
          var u = navigator.userAgent,
            app = navigator.appVersion;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isAndroid) {
            return 'android';
          }
          if (isIOS) {
            return 'ios';
          }
        } else {
          return 'web';
        }
      },
      blurAdjust() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          document.activeElement.scrollIntoViewIfNeeded(true);
        }
      },
      urlToBase64: function (url) {
        return new Promise((resolve, reject) => {
          let image = new Image();
          image.onload = function () {
            let canvas = document.createElement('canvas');
            canvas.width = this.naturalWidth;
            canvas.height = this.naturalHeight;
            // 将图片插入画布并开始绘制
            canvas.getContext('2d').drawImage(image, 0, 0);
            // result
            let result = canvas.toDataURL('image/png')
            resolve(result);
          };
          // CORS 策略，会存在跨域问题https://stackoverflow.com/questions/20424279/canvas-todataurl-securityerror
          image.setAttribute("crossOrigin", 'Anonymous');
          image.src = url;
          // 图片加载失败的错误处理
          image.onerror = () => {
            reject(new Error('urlToBase64 error'));
          };
        })
      },
      handleOnTell(phoneNumber){
        if (!checkIsApp()) {
          window.location.href = `tel:${phoneNumber}`;
          return
        }
        try {
          uni.postMessage({
            data: {
              action: 'onTell',
              data: {phoneNumber:phoneNumber}
            }
          });
				  window.webkit.messageHandlers.onTell.postMessage(phoneNumber);
        } catch (err) {
			    window.gk.onTell(phoneNumber);
        }
      },
      // 是否在app内
      checkIsApp () {
        let uniHm = sessionStorage.getItem('uniHm') // uniHm=1 表示uniapp打包成鸿蒙app
        let isApp = false
        try{ window.getData = function(data) { } }catch(err){ }
        try {
          window.webkit.messageHandlers.request.postMessage('getData');
          isApp = true
        } catch (err) {
          try{
            window.gk.request('getData')
            isApp = true
          } catch(err){
            isApp = false
          }
        }
        if (uniHm == '1') {
          isApp = true
        }
        return isApp
      },
      // app端返回
      goAppBack () {
        try {
          uni.postMessage({
            data: {
              action: 'showBack'
            }
          });
          window.webkit.messageHandlers.showBack.postMessage('');
        } catch (err) {
          window.gk.showBack();
        }
      },
    }
  }
}
export default uilts
